import { ExportTransportTypes } from 'constants/exportTypes';

import { Alert } from 'shared/mui/Alert/Alert';
import { DateRangeValue } from 'shared/mui/DatePicker/DateRangeTimezonePicker/DateRangeTimezonePicker';
import { DateRangeTimezoneValue } from 'shared/mui/DatePicker/DateTimeRangeTimezonePicker/DateTimeRangeTimezonePicker';
import { FilterFields } from 'shared/mui/Filter/FilterFields/FilterFields';

import { useCumulativeReportFilterFields } from './hooks/useCumulativeReportFilterFields';

export type CumulativeReportFilterValues = {
  appliedDate?: DateRangeValue;
  currency?: string | null;
  periodFrom?: number | null;
  periodTo?: number | null;
  company?: string | null;
  merchant?: string | null;
  provider?: string | null;
  merchantAccounts?: string[] | [];
  exportType?: string;
  accountsSummary?: boolean | null;
  jobType?: string;
  notificationTransport?: [ExportTransportTypes.Email];
  timezone?: DateRangeTimezoneValue;
};

export const CumulativeReportFilter: React.FC = () => {
  const fields = useCumulativeReportFilterFields();

  return (
    <>
      <Alert severity="warning">
        Период формирования отчёта не должен превышать 31 календарный день!
      </Alert>
      <FilterFields fields={fields} />
    </>
  );
};
